module.exports = __webpack_public_path__ + "img/GE.20aa9ab5.svg";